
interface GamePropertyJson {
  game_type: GameType,
  theme: string,
  script_url: string,
  resource_path: string,
  event_content: string,
  play_requirements: boolean,
  play_limit: number,
  challenge_limit: number,
  lottery_rule_is_dynamic?: boolean,
}

export enum GameType {
  Janken = 1,
  Barrel = 4,
  Scratch = 6,
  Roulette = 8,
  Slot = 9,
  SelectCard = 10,
  Gameless = 12,
  WhackMole = 14,
  Balloon = 15,
  Gacha = 16,
  WaniPanic = 17,
  MovieGacha = 18,
  TurningLottery = 19,
  Crane = 20,
  Memory = 21,
  PresentCatch = 27,
}

export class Property {

  constructor(
    private parameters: GamePropertyJson
  ) { }

  get type(): GameType {
    return this.parameters.game_type
  }

  get theme(): string {
    return this.parameters.theme
  }

  get scriptUrl(): string {
    return this.parameters.script_url
  }

  get resourcePath(): string {
    return this.parameters.resource_path
  }

  get eventContent(): string {
    return this.parameters.event_content
  }

  get playRequirements(): boolean {
    return this.parameters.play_requirements
  }

  get playLimit(): number {
    return this.parameters.play_limit
  }

  get challengeLimit(): number {
    return this.parameters.challenge_limit
  }

  get lotteryRuleIsDynamic(): boolean {
    return this.parameters.lottery_rule_is_dynamic || false
  }
}
